var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconProfileDefault = function SvgIconProfileDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "#F4F4F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon_profile_default_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 47
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 22.633,
    fill: "#F4F4F5",
    stroke: "#9FA4AB",
    strokeWidth: 1.733
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_profile_default_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.676 38.798c-3.945-5.31-8.56-6.975-21.841-6.975-13.282 0-17.897 1.664-21.842 6.975C-3.284 45.9 13.232 50.33 23.835 50.33c10.603 0 27.118-4.43 21.841-11.532ZM27.742 7.346s7.384 1.885 6.936 9.234c-.425 6.924-3.573 9.663-5.873 11.033-1.447.861-4.165 1.925-8.065 1.069C5.193 25.265 12.248.903 27.742 7.346Z",
    fill: "#E7E8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.663 27.647.19 5.775s-.559 1.057-3.423 1.057c-4.771 0-5.165-1.166-5.165-1.166l.576-8.784 7.822 3.118Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.694 27.92.068 2.888-4.564-2.355 4.495-.533Z",
    fill: "#E7E8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.33 11.425s.903-3.556 3.654 3.614c1.088 2.838 1.495 6.009.023 9.51-1.473 3.503-4.244 4.245-5.24 4.359-2.061.236-5.449-.478-6.765-3.856-1.608-4.128 2.524-18.126 8.328-13.627Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.062 24.52s-.85 1.403-3.043.61c-1.594-.57-2.344-2.633-1.659-4.13.685-1.497 1.992-1.868 3.143-1.712 1.15.156 1.586.761 1.586.761",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.829 7.776a3.216 3.216 0 0 0-2.093-.43c-.395.103-.802.15-1.21.143-2.813-.217-13.125 1.66-11.826 11.12.206 1.494 2.186 3.39 4.566 3.269 2.676-.137 4.846-2.568 5.22-6.002.372-3.433 2.472-5.066 3.88-3.717a.282.282 0 0 0 .418-.042c.263-.363.693-.555 1.66.676 1.262 1.609 2.472 4.409 2.472 8.38 0 1.376.251 1.015-.011 2.232 1.557-2.935 1.883-5.389 1.902-6.116.184-5.66-3.517-8.662-4.978-9.513Z",
    fill: "#E7E8EA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 22.633,
    stroke: "#E7E8EA",
    strokeWidth: 1.733
  }))));
};
export default SvgIconProfileDefault;